import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { SignaturePackage } from './components/SignaturePackage';
import { WhyMobileBartender } from './components/WhyMobileBartender';
import { AdditionalServices } from './components/AdditionalServices';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { LanguageProvider } from './lib/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-[#FFF8F0] text-zinc-900 font-sans selection:bg-[#D4A843] selection:text-white" data-id="element-1">
        <TopBar data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <About data-id="element-5" />
          <SignaturePackage data-id="element-6" />
          <WhyMobileBartender data-id="element-7" />
          <AdditionalServices data-id="element-8" />
          <CallToAction data-id="element-9" />
        </main>
        <Footer data-id="element-10" />
      </div>
    </LanguageProvider>;
}